import axios from "axios";
import { environment } from "../../../environments/environment";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { array } from "@amcharts/amcharts5";

export function getRepairTypes(){
    return axios.post(`${environment.getDropdownData}`, {
        id: 95, 
        filters: [],
        dependencies: [],
        page: 0,
        pageSize: 200,
        parameters: [],
        parentComponentId: null,
        search: ""
    })
}

export function getPartRepairSites(partId){
    return axios.post(`${environment.getPartRepairSites}`,[{
        columnName: "partId",
        value: partId
    },
    {"columnName": "accountId", value: parseInt(localStorage.getItem('u_account_id'))}
])
}

export function getRepairsbySitePart(partId, siteId){
    return axios.post(`${environment.getSiteRepairs}?partId=${partId}&siteId=${siteId}`,[{"columnName": "accountId", value: parseInt(localStorage.getItem('u_account_id'))}])
}


export function getPartConditions(costType){
    return axios.post(`${environment.getDropdownData}`, {
        id: costType === "C"  ? 96: 95, 
        filters: [],
        dependencies: [],
        page: 0,
        pageSize: 200,
        parameters: [],
        parentComponentId: null,
        search: ""
    })
}

export function saveSiteRepairTypes(array){
    return axios.post(`${environment.saveSiteRepairs}`, array);
}

export function deleteRepairTypes(array){
    return axios.request({url:`${environment.deleteSiteRepairs}`, method: "DELETE", data: array});
}
export function deleteRepairTypesBySite(siteId, partId){
    return getRepairsbySitePart(partId, siteId).then(
        response =>{
            if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                let repairsToDelete = response.data.load.filter(i => i.id);
                return deleteRepairTypes(repairsToDelete ?? []);
            }
        }
    )
}

export function getPartVendors(partId, key, vendorParams){
    const urlParams = new URLSearchParams({...vendorParams, type:key});
    // return axios.post(`${environment.getPartVendors}?type=${key}`, [{columnName: "partId", value: partId}, {columnName: "companyId", value: parseInt(localStorage.getItem("u_company_id"))}])
    return axios.post(`${environment.getPartVendors}?${urlParams.toString()}`, [{columnName: "partId", value: partId}, {columnName: "accountId", value: parseInt(localStorage.getItem("u_account_id"))}])
}

export function getConditionCosts(tatId){
    return axios.post(`${environment.getPartVendorsCosts}`,[{columnName: "partVendorId", value: tatId}, {columnName: "accountId", value: parseInt(localStorage.getItem("u_account_id"))}]);
}
 
export function  getTATInfo(partId, vendorId, conditionIds, costType){
    return Promise.all(conditionIds.map(conditionId => axios.get(`${costType === "C" ? environment.getPartVendorCondition : environment.getPartVendorRepair}?partId=${partId}&vendorId=${vendorId}&${costType === "C" ? "partConditionId":"repairTypeId"}=${conditionId}`).then(response => {
        return {load: response.data.load, conditionId};
    })));
    // let params = new URLSearchParams(paramsObj);
    // return axios.get(`${environment.getPartVendorCondition}?${params.toString()}`)
}

export function  saveTatInfo(tatInfo){
    return  axios.put(`${environment.saveTATInfo}`, tatInfo)
    // return axios.request({
    //     url: `${environment.saveTATInfo}?partId=${tatInfo.partId}`,
    //     method: typeof(tatInfo.id)==='number' ? "PUT": "PUT",
    //     data: tatInfo
    // })
    // return axios.post(`${environment.saveTATInfo}?partId=${tatInfo.partId}`,tatInfo)
}

export function deleteTatInfo(tatInfoId){
    return axios.delete(`${environment.deleteTatInfo}?id=${tatInfoId}`);
}

export function getCurrencies() {
    return axios.post(`${environment.getDropdownData}`, {
        "id": 74,
        "search": "",
        "dependencies": [],
        "page": 0,
        "pageSize": 200,
        "parentComponentId": null,
        "filters": [],
        "parameters": []
    })
}

export function saveCostsReq(costInfo){
    if (costInfo.id ===null){
        return axios.post(`${environment.saveVendorCost}`, {...costInfo, unitCosts: [], maxUnitCost: "", minUnitCost: ""}).then(response =>
            {if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.SUCCESS, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode)){
              return axios.post(`${environment.saveVendorCost}`, {...response.data.load, ...costInfo, id: response.data.load.id, maxUnitCost: "", minUnitCost: "", unitCosts: costInfo.unitCosts.map(c => ({...c, partVendorQuantityCostId: response.data.load.id, accountId: parseInt(localStorage.getItem('u_account_id'))}))})  
            }}
        )
    }
    return axios.post(`${environment.saveVendorCost}`, {...costInfo,maxUnitCost: "", minUnitCost: "", unitCosts: costInfo.unitCosts.map(c => ({...c, partVendorQuantityCostId: costInfo.id})) });
}

export function deleteRangeReq(rId){
    return axios.delete(`${environment.deleteCostRange}?id=${rId}`)
}

export function getSpecificCost(costHistoryId){
    return axios.get(`${environment.getSpecificCost}?id=${costHistoryId}`)

}